<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="rating.id === null">{{ 'NEWRATING' | translate }}</span>
            <span *ngIf="rating.id !== null">{{ 'EDITRATING' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="ratingForm" id="ratingForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="ratingForm" >
            <input type="hidden" name="id" id="ratingId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-table "></i>
                    </span>
                    <span class="p-float-label">
                      <input id="ratingEntity" formControlName="entity" type="text" pInputText [required]="true"> 
                      <label for="ratingEntity" class="req">{{ 'ENTITY' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="ratingForm.controls['entity'].invalid && (ratingForm.controls['entity'].dirty || ratingForm.controls['entity'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="ratingForm.controls['entity'].errors !== null">
                  <div *ngIf="ratingForm.controls['entity'].errors.required">
                   {{ 'ENTITYREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-project-diagram "></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="ratingForeignKey" formControlName="foreignKey" [step]="1" [showButtons]="true" [required]="true"></p-inputNumber>
                      <label for="ratingForeignKey" class="req">{{ 'FOREIGNKEY' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="ratingForm.controls['foreignKey'].invalid && (ratingForm.controls['foreignKey'].dirty || ratingForm.controls['foreignKey'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="ratingForm.controls['foreignKey'].errors !== null">
                  <div *ngIf="ratingForm.controls['foreignKey'].errors.required">
                   {{ 'FOREIGNKEYREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-gem "></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="ratingValue" formControlName="value" [step]="1" [showButtons]="true" [required]="true"></p-inputNumber>
                      <label for="ratingValue" class="req">{{ 'VALUE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="ratingForm.controls['value'].invalid && (ratingForm.controls['value'].dirty || ratingForm.controls['value'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="ratingForm.controls['value'].errors !== null">
                  <div *ngIf="ratingForm.controls['value'].errors.required">
                   {{ 'VALUEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKRATINGS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="rating.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!ratingForm.valid || disableSubmit"> <!--  [disabled]="ratingForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!ratingForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

